import { render, staticRenderFns } from "./buyProduct.vue?vue&type=template&id=ddfad64e&scoped=true"
import script from "./buyProduct.vue?vue&type=script&lang=js"
export * from "./buyProduct.vue?vue&type=script&lang=js"
import style0 from "./buyProduct.vue?vue&type=style&index=0&id=ddfad64e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfad64e",
  null
  
)

export default component.exports